import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'; 

export interface TableSubHeader {
  label: string;
  key?: string;
  centered?: boolean;
  sortable?: boolean;
  minWidth?: string;
}

export interface TableHeader {
  label: string,
  colspan: number
}

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements OnInit {

  @Input() isLoading = Boolean(false);
  @Input() tableHeader? : TableHeader[];
  @Input() tableSubHeader! : TableSubHeader[];
  @Input() centeredContent = false;
  @Input() sort_type: 'ASC' | 'DESC' = 'ASC'; // Accept current sort type from parent
  @Input() stickyLastColumn = false;   // true if the last column should be sticky, false otherwise
  @Input() defaultMinWidth = '170px'; // pick your default
  @Output() toggleOnSort = new EventEmitter<any>();
  ngOnInit(): void {
    if (!this.tableSubHeader) {
      throw new TypeError("'Sub Header' is required");
    }
  }

  sortList(key: string, type: 'ASC' | 'DESC'): void {
    this.toggleOnSort.emit({ key, type });
  }

  // Check if a column is sortable (defaults to true if not specified)
  isSortable(subHeader: TableSubHeader): boolean {
    return subHeader.sortable !== false;
  }
  
}
